import { take } from "../../util";
export const fromGql = (item) => (Object.assign({}, (take(item, 'limitValue', 'totalCount', 'totalPages', 'currentPage'))));
//# sourceMappingURL=CollectionMetadata.js.map